module.exports = __webpack_public_path__ + "img/greater_water_elemental_small.20f8a080.png";